import { inject } from "@angular/core";
import { forkJoin } from "rxjs";
import { ActivityLogsService } from "shared/services/activity-logs.service";
import { ClientsService } from "shared/services/clients.service";
import { DocumentsService } from "shared/services/documents.service";
import { ProductsService } from "shared/services/products.service";
import { KsefInvoicesService } from "shared/services/ksef-invoices.service";

export const accountResolver = () => {

    const documentsService = inject(DocumentsService);
    const clientsService = inject(ClientsService);
    const productsService = inject(ProductsService);
    const activityLogsService = inject(ActivityLogsService);
    const ksefInvoicesService = inject(KsefInvoicesService);
    
    return forkJoin([
        documentsService.getAll(),
        clientsService.getAll(),
        productsService.getAll(),
        activityLogsService.getAll(),
        ksefInvoicesService.getAll()
    ]);
}
